var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"lp-child-base basic-input",style:(_vm.styles)},[_c('block-title',{attrs:{"target-info":_vm.targetInfo,"color-scheme":_vm.colorScheme}}),_vm._v(" "),_c('block-fortune-input',{attrs:{"target-info":_vm.targetInfo,"color-scheme":_vm.colorScheme,"action":_vm.action,"method":_vm.method,"token":_vm.token,"lp-id":_vm.lpId,"pageLabel":"basicinput"}})],1)}
var staticRenderFns = []
export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4d4cb0e0","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/js/utvStore/components/recommend/lp/counselor/kurenotori/BasicInput.vue
// module id = null
// module chunks = 